<template>
    <nav class="navbar">
        <div class="navbar-space" @click="ToggleNavbar"></div>
        <div class="navbar-menu">
            <div class="flex flex-row items-center justify-around py-3 w-full cursor-pointer sticky top-0 background" @click="ToggleNavbar">
                <p class="title-sm select-none">Samgk <b class="text-gradient select-none">DPO</b></p>
                <button class="ml-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
            </div>
            <div class="navbar-menu-item" @click="GoTo('Home')">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
                    </svg>
                </p>
                <p>Личный кабинет</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('UserList')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                    </svg>
                </p>
                <p>Пользователи</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('ProgramList')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </p>
                <p>Программы</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('GroupList')" v-if="$root.HasRole($store.state.employeeRole) || $root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                    </svg>
                </p>
                <p>Учебные группы</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('CourseList')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 576 512" fill="currentColor">
                        <path d="M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5l0-377.4c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8L0 454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5l0-370.3c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11L304 456c0 11.4 11.7 19.3 22.4 15.5z"/>
                    </svg>
                </p>
                <p>Курсы</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('RecordList')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19.903 8.586a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.952.952 0 0 0-.051-.259c-.01-.032-.019-.063-.033-.093zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"></path>
                        <path d="M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"></path>
                    </svg>
                </p>
                <p>Записи на курсы</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('ContractList')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                    </svg>
                </p>
                <p class="text-sm">Журнал документов</p>
            </div>
            <div class="navbar-menu-item" @click="$root.ShowModal('#ReportBug')" v-if="false">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"/>
                        <path d="M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z"/>
                    </svg>
                </p>
                <p class="text-sm">Сообщить об ошибке</p>
            </div>
            <div class="navbar-menu-item" @click="Logout">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                </p>
                <p>Выход</p>
            </div>
        </div>
        <div class="flex flex-row items-center justify-between">
            <button class="" @click="ToggleNavbar">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
                </svg>
            </button>
            <p class="title-sm ml-2 select-none">Samgk <b class="text-gradient select-none">DPO</b></p>
        </div>
        <div class="flex flex-row items-center justify-between">
            <button class="mr-2" @click="$root.ToggleDarkMode">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-800" viewBox="0 0 20 20" fill="currentColor" v-if="$store.state.mode === 'dark'">
                    <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor" v-else-if="$store.state.mode === 'light'">
                    <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
                </svg>
            </button>
            <p class="font-bold">{{login}}</p>
        </div>
    </nav>

    <div class="modal dark:text-white" id="ReportBug" @click="$root.HideModal('#ReportBug')">
        <form class="modal-dialog" @submit="ReportBug" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Сообщение об ошибке</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ReportBug')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col w-full my-2">
                    <label class="input-label">Опишите проблему</label>
                    <textarea class="input max-w-[99%] h-36 ml-1" ref="report_content"></textarea>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#ReportBug')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ReportBug')">Отправить</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            login: ""
        }
    },
    methods: {
        ReportBug(e) {
            e.preventDefault()
        },
        Logout() {
            this.$router.push({name: 'Logout'})
        },
        GoTo(name) {
            this.$router.push({name: name})
        },
        ToggleNavbar() {
            let navbar = document.querySelector("nav.navbar")
            let menu = navbar.querySelector(".navbar-menu")
            let space = navbar.querySelector(".navbar-space")
            if (this.show) {
                menu.classList.add("hide")
                space.classList.remove("show")
                setTimeout(()=>{
                    menu.classList.remove("show")
                    menu.classList.remove("hide")
                }, 400)
            } else {
                menu.classList.add("show")
                space.classList.add("show")
            }
            this.show = !this.show
        },
        GetLogin() {
            fetch(this.$store.state.apiAddr + "/v1.0/users/me/login", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
                
            })
            .then(response =>{return response.json()})
            .then(res => {
                if (this.$root.HandleFetchError(res)) return

                if (res["data"]["login"] !== undefined || res["data"]["login"] !== null) {
                    this.login = res["data"]["login"]
                }
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
    },
    created() {
        if (this.$root.GetToken() != null) {
            this.GetLogin()
        }
    }
}
</script>